const Divider = () => {
  return <div className="divider" />;
};

export { Divider };
